import '../../../../components/Recaps/DefaultRecap/recaps.css';

import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { Link, Typography, useTheme } from '@mui/material';
import { memo } from 'react';

import { getRecapStyle } from '../../../../components/Recaps/DefaultRecap/recap-style';
import { CustomThemeInterface } from '../../../../interface/custom-theme';
import { RootState } from '../../../../store';
import { useAppSelector } from '../../../../store/hooks';
import { MULTI_STORE_PANEL_TOGGLE_ID } from './multi-store-a11y';

interface MultiStoreRecapRowProps {
  text: string;
  actionText: string;
  // il pannello dei centri, subito sotto la riga, è aperto
  isExpanded: boolean;
  panelId: string;
  // una riga sola, troncata con i puntini quando non entra (riepilogo dei centri)
  isTruncated?: boolean;
  onAction: () => void;
}

const selectRectangle = (
  state: RootState
): CustomThemeInterface['rectangle'] => state.customTheme.customTheme.rectangle;

// Riga con la stessa resa dei riepiloghi in alto (DefaultRecap, classe "single-recap"):
// icona primary, testo e link con la variant recap. Il link apre e chiude il pannello dei
// centri, come un bottone di espansione, e riprende il focus quando il pannello si chiude.
export const MultiStoreRecapRow = memo(function MultiStoreRecapRow({
  text,
  actionText,
  isExpanded,
  panelId,
  isTruncated = false,
  onAction,
}: MultiStoreRecapRowProps): JSX.Element {
  const { palette } = useTheme();
  const rectangle = useAppSelector(selectRectangle);

  return (
    <div
      className="single-recap multi-store-recap"
      style={getRecapStyle(palette, rectangle)}
    >
      <div className="icon">
        <StorefrontOutlinedIcon color="primary" style={{ fontSize: '30px' }} />
      </div>
      <div className="text">
        <div className="text-inner">
          <Typography
            variant="recap"
            component="div"
            noWrap={isTruncated}
            title={isTruncated ? text : undefined}
            style={{ textAlign: 'left' }}
          >
            {text}
          </Typography>
        </div>
      </div>
      <div className="change1">
        <Link
          id={MULTI_STORE_PANEL_TOGGLE_ID}
          component="button"
          variant="recap"
          className="multi-store-link"
          aria-expanded={isExpanded}
          aria-controls={isExpanded ? panelId : undefined}
          onClick={onAction}
        >
          {actionText}
        </Link>
      </div>
    </div>
  );
});
